export default "__VITE_ASSET__DMQDQsyJ__"